import { render, staticRenderFns } from "./PersonalLiabilityList.vue?vue&type=template&id=9f66864c"
import script from "./PersonalLiabilityList.vue?vue&type=script&lang=ts"
export * from "./PersonalLiabilityList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports